import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {AppTerms} from "../../../app/app-terms";
import {EntitySelectionComposer} from "../entity-selection-composer";
import styles from "../entity-selection.module.scss"
import classNames from "classnames";

export class StarIconComponentProps extends BaseProps {
  i18n: AppTerms;
  isActive: Boolean;
  onClick: Function;
  size: Number = 16;
  className: String;
}

export const FollowSelectionButton = EntitySelectionComposer(({
                                                                isActive,
                                                                onClick,
                                                                className,
                                                                activeClassName,
                                                                i18n,
                                                              }: StarIconComponentProps) => {

  const label = isActive ? i18n.WEB_FOLLOW_BUTTON_FOLLOWING : i18n.WEB_FOLLOW_BUTTON;

  const followProps = {
    className: classNames(className, styles.follow, 'clickable', {[activeClassName]: isActive}),
    onClick: (e) => onClick(e),
  }

  return <div {...followProps}>{label}</div>
});
